import { useEffect, useState } from 'react';
import { ContentType, ContentTypes } from '../common/enums/ContentTypes';
import { IContent } from '../common/interfaces/Content.interface';
import { IMedia } from '../common/interfaces/Media.interface';

interface UseMediaGalleryReturn {
  showMediaGallery: boolean;
  selectedMedia: IMedia | null;
  setShowMediaGallery: (show: boolean) => void;
  handleSelectMedia: (media: IMedia | null) => void;
  handleSubmitSelectedMedia: () => void;
  handleCloseMediaModal: () => void;
}

export const useMediaGallery = (
  contentState: IContent | null,
  updateContentField: (
    field: keyof IContent,
    value: IMedia | ContentType | null
  ) => void
): UseMediaGalleryReturn => {
  const [showMediaGallery, setShowMediaGallery] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState<IMedia | null>(
    contentState?.media || null
  );

  useEffect(() => {
    if (contentState?.media && showMediaGallery) {
      setSelectedMedia(contentState?.media);
    }
  }, [contentState?.media, showMediaGallery]);

  const handleSelectMedia = (media: IMedia | null) => {
    setSelectedMedia(media);
  };

  const handleCloseMediaModal = () => {
    setShowMediaGallery(false);
    setSelectedMedia(null);
  };

  const handleSubmitSelectedMedia = () => {
    updateContentField('media', selectedMedia);
    updateContentField(
      'contentType',
      (selectedMedia?.type as ContentType) || ContentTypes.TEXT
    );
    handleCloseMediaModal();
  };

  return {
    showMediaGallery,
    selectedMedia,
    setShowMediaGallery,
    handleSelectMedia,
    handleSubmitSelectedMedia,
    handleCloseMediaModal,
  };
};
